import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../../Services/auth.service';

export const PrivateRoute = ({ children, roles }) => {
  const user = authService().currentUser();
  if (!user) {
    return <Navigate to="/login" />;
  }
  if (roles && roles.length > 0 && !roles.includes(user.rol)) {
    return <Navigate to="/login" />;
  }

  return children;
};
